import { apiFetch } from '../api/api';

const base = '/api/control-plane/v1';
const segment = value => {
  if (typeof value !== 'string' || !value || value !== value.trim()) throw new Error('Invalid application context');
  return encodeURIComponent(value);
};

export const loadCatalog = signal => apiFetch(`${base}/catalog`, { signal });

export const loadOrganizationApps = (organizationId, signal) => apiFetch(
  `${base}/organizations/${segment(organizationId)}/apps`,
  { signal, headers: { 'X-Org-Id': organizationId } }
);

export const launchApplication = (organizationId, applicationId, signal) => apiFetch(
  `${base}/organizations/${segment(organizationId)}/applications/${segment(applicationId)}/launch`,
  { method: 'POST', body: {}, signal, headers: { 'X-Org-Id': organizationId } }
);

// Navigation safety only, not an authorization check. Never navigate from a
// card/query URL; Phase 1 supports just these two internal destinations.
export function internalLaunchTarget(result, organizationId, applicationId) {
  if (result?.launchMode !== 'internal' || result.organizationId !== organizationId ||
      result.applicationId !== applicationId || !['/datasets', '/gallery/datasets'].includes(result.launchTarget)) {
    throw new Error('Invalid launch response');
  }
  return result.launchTarget;
}
